<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>

    <div class="list"
         v-if="boxIndex==1">
      <div class="toptitle">
        <div class="ttLeft">
          <span>我的link</span>
        </div>
        <div class="ttRight"
             @click="boxIndex=2">
          <span>新增</span>
        </div>
      </div>
      <div class="listbox">
        <table>
          <thead>
            <tr>
              <th>Link图片</th>
              <th>Link文字</th>
              <th>外链</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in storeList"
                :key="index">
              <td>
                <img :src="item.pictureUrl"
                     style="width:30px;height:30px"
                     alt="">
              </td>
              <td>{{item.title}}</td>
              <td>{{item.l_Url}}</td>
              <td>
                <img style="margin-right:10px;cursor: pointer;"
                     src="../../assets/img/icon/bianji.png"
                     @click="toUpdate(item.id)"
                     alt="">
                <img src="../../assets/img/icon/shanchu.png"
                     style="cursor: pointer;"
                     @click="toDelete(item.id)"
                     alt="">
              </td>
            </tr>
            <tr v-show="storeList.length<1">
              <td colspan="4">暂无资源信息</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination :total="pageCount"
                  :limit="pageSize"
                  :page="pageIndex"
                  @page-change="pageChange"></pagination>
    </div>
    <div class="form"
         v-if="boxIndex==2">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="93px"
               label-position="right"
               class="demo-ruleForm">
        <el-form-item label="Link名称："
                      prop="name">
          <el-input v-model="ruleForm.name"
                    placeholder="请输入Link名称"
                    style="width: 880px;"></el-input>
        </el-form-item>
        <div class="formBox">
          <div class="formLeft">
            <el-form-item label="Link选择："
                          prop="type">
              <el-select v-model="ruleForm.type"
                         style="width: 360px;"
                         placeholder="请选择">
                <el-option v-for="item in options"
                           :key="item.id"
                           :label="item.title"
                           :value="item.id">
                  <div style="display:flex;align-items: center;">
                    <img :src="item.pictureUrl"
                         style="width:20px;height:20px;margin-right:10px"
                         alt="">
                    <span>{{item.title}}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="Link外链："
                          prop="url">
              <el-input v-model="ruleForm.url"
                        placeholder="请输入链接地址"
                        style="width: 360px;"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <div class="xzbtn"
               style="margin-left:280px"
               @click="submitForm">提交</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'usInfor',
  data () {
    return {
      storeName: '',
      options: [],
      ruleForm: {
        name: '',
        type: '',
        url: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入Link名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择Link', trigger: 'change' }
        ],
        url: [
          { required: true, message: '请输入链接地址', trigger: 'blur' }
        ],
      },
      storeList: [],
      pageCount: 0,
      pageSize: 6,
      pageIndex: 1,
      boxIndex: 1
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.getOptions()
    this.getStoreList()
  },
  methods: {
    getOptions () {
      this.httphelper.get('/api/CGPExpertApi/GetLinkConfigList').then(res => {
        if (res.code == 200) {
          this.options = res.data
        }
      });
    },
    getStoreList () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertLinkList', {
        type: 2,
        Id: Number(localStorage.getItem('storeId')),
        IsShow: false,
        Page: this.pageIndex,
        limit: this.pageSize
      }).then(res => {
        if (res.code == 200) {
          this.storeList = res.data
          this.pageCount = res.totalcount
        }
      });
    },
    pageChange (page) {
      if (page == this.pageIndex) return;
      this.pageIndex = page;
      this.getStoreList()
    },
    submitForm () {
      if (this.ruleForm.name == '') return this.$message.warning('Link名称不能为空');
      else if (this.ruleForm.type == '') return this.$message.warning('请选择Link');
      else if (this.ruleForm.url == '') return this.$message.warning('Link外链不能为空');
      this.httphelper.post('/api/CGPExpertApi/SaveExpertLink', {
        id: 0,
        expertId: Number(localStorage.getItem('storeId')),
        l_Pid: this.ruleForm.type,
        lurl: this.ruleForm.url,
        title: this.ruleForm.name,
        is_Start: 1,
        type: 2
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('新增link成功');
            this.ruleForm.name = ''
            this.ruleForm.type = ''
            this.ruleForm.url = ''
            this.getStoreList()
            this.boxIndex = 1
          } else {
            this.$message.error('新增link失败');
            this.boxIndex = 1
          }
        });
    },
    toUpdate (id) {
      this.$router.push({
        name: 'uaUpdateLink',
        query: {
          id: id,
        },
      })
    },
    toDelete (id) {
      this.$confirm('您确定要删除该link?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.httphelper.post('/api/CGPExpertApi/DelLinkById', {
          id: id
        })
          .then(res => {
            if (res.data.code == 200) {
              this.$message.success('删除link成功');
              this.getStoreList()
            } else {
              this.$message.error('删除link失败');
            }
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    }
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    height: 57px;
    background: #f6f7fb;
    padding-left: 17px;
    padding-right: 19px;
    margin: 30px 0 40px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.ttLeft {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
}
.ttRight {
    width: 83px;
    height: 32px;
    background: #0b8586;
    border-radius: 3px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.xzbtn {
    margin-top: 60px;
    margin-left: 375px;
    width: 200px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
}
.formBox {
    display: flex;
    justify-content: space-between;
}
.form {
    margin-top: 30px;
}
.list {
    margin-top: 10px;
}
.b1top {
    margin: 20px 0;
    height: 18px;
    line-height: 18px;
    padding-left: 14px;
    border-left: 2px solid #0b8586;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.b1top span {
    margin-right: 40px;
    cursor: pointer;
}
.b1tr {
    display: flex;
    align-items: center;
}
.b1tr img {
    margin-right: 10px;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
</style>